import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Edit2, Trash2 } from "lucide-react";

/**
 * Sortable mobile product card. Touch-friendly:
 * the grip handle activates dragging (long-press safe via @dnd-kit sensors).
 */
export default function ProductCardMobile({ product, idx, checked, onCheck, onEdit, onDelete }) {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({ id: product.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    zIndex: isDragging ? 30 : "auto",
    boxShadow: isDragging ? "0 8px 24px rgba(122,31,43,0.25)" : undefined,
  };
  const cats = (product.categories && product.categories.length ? product.categories : [product.category]).filter(Boolean);

  return (
    <div
      ref={setNodeRef}
      style={style}
      data-testid={`admin-row-${product.slug}`}
      className={`bg-white border rounded-lg p-3 flex gap-3 ${checked ? "border-[#7A1F2B] bg-[#FFE7F1]/50" : "border-[#E5DBD8]"}`}
      {...attributes}
    >
      <button
        ref={setActivatorNodeRef}
        type="button"
        {...listeners}
        className="p-1 -ml-1 text-[#5C5555] cursor-grab active:cursor-grabbing touch-none self-start"
        data-testid={`product-drag-${product.slug}`}
        aria-label={`Drag ${product.name} to reorder`}
        title="Drag to reorder"
      >
        <GripVertical className="w-5 h-5"/>
      </button>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheck(product.id, e.target.checked)}
        data-testid={`product-check-${product.slug}`}
        className="w-4 h-4 accent-[#7A1F2B] cursor-pointer shrink-0 mt-1"
      />
      <img src={product.images[0]} alt="" className="w-16 h-16 object-cover rounded shrink-0"/>
      <div className="flex-1 min-w-0">
        <p className="font-serif text-sm text-[#2D2424] leading-tight">{product.name}</p>
        <div className="mt-1 flex flex-wrap gap-1">
          {cats.map((c) => (
            <span key={c} className="inline-block bg-[#FFE7F1] text-[#7A1F2B] text-[10px] px-1.5 py-0.5 rounded-full capitalize">{c}</span>
          ))}
        </div>
        <div className="mt-1.5 flex items-center gap-3 text-xs text-[#5C5555]">
          <span className="font-semibold text-[#2D2424]">₹{product.price.toLocaleString("en-IN")}</span>
          <span>Stock: {product.stock}</span>
          {product.featured && <span className="text-[#FFB800]">★ Featured</span>}
          <span className="text-[10px] text-[#5C5555]">#{idx + 1}</span>
        </div>
      </div>
      <div className="flex flex-col gap-1.5 shrink-0">
        <button onClick={() => onEdit(product)} data-testid={`admin-edit-${product.slug}`} className="w-8 h-8 rounded-full border border-[#E5DBD8] text-[#7A1F2B] flex items-center justify-center hover:bg-[#FFE7F1]"><Edit2 className="w-4 h-4"/></button>
        <button onClick={() => onDelete(product)} data-testid={`admin-delete-${product.slug}`} className="w-8 h-8 rounded-full border border-[#E5DBD8] text-[#7A1F2B] flex items-center justify-center hover:bg-[#FFE7F1]"><Trash2 className="w-4 h-4"/></button>
      </div>
    </div>
  );
}
